import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

/**
 * MarketNest cards are deliberately flat — no shadow. Depth comes from the
 * border weight and from cream layered on white, so `elevated` gets a heavier
 * border and the warm ground rather than a drop shadow.
 */
const card = cva('rounded-card p-5 transition-colors', {
  variants: {
    variant: {
      default: 'border border-border-subtle bg-surface hover:border-border-strong',
      elevated: 'border-2 border-border-strong bg-surface-muted hover:border-border-loud',
    },
  },
  defaultVariants: { variant: 'default' },
});

export type CardProps = ComponentProps<'section'> & VariantProps<typeof card>;

export function Card({ className, variant, ...props }: CardProps) {
  return <section className={cn(card({ variant }), className)} {...props} />;
}

/** Lora carries the handcrafted, editorial voice the system asks headings for. */
export function CardTitle({ className, ...props }: ComponentProps<'h2'>) {
  return (
    <h2 className={cn('font-display text-body-lg font-semibold text-ink', className)} {...props} />
  );
}
